module.exports = __webpack_public_path__ + "static/media/wag.49ef61b3.png";